import type { UnitSystem } from '@trainme/api/client';

export type StrengthWeightDisplayUnit = 'KILOGRAM' | 'POUND';

const COOKIE_NAME = 'trainme_strength_weight_unit';

export const getDefaultStrengthWeightUnit = (): StrengthWeightDisplayUnit =>
  'POUND';

export const unitToLabel = (unit: StrengthWeightDisplayUnit) =>
  unit === 'POUND' ? 'lb' : 'kg';

export const strengthWeightUnitToDisplay = (
  unitSystem: UnitSystem | null | undefined
): StrengthWeightDisplayUnit => {
  if (unitSystem === 'scientific') return 'KILOGRAM';
  return 'POUND';
};

export const readStrengthWeightUnitCookie =
  (): StrengthWeightDisplayUnit | null => {
    if (typeof document === 'undefined') return null;

    const cookie = document.cookie
      .split(';')
      .map((part) => part.trim())
      .find((part) => part.startsWith(`${COOKIE_NAME}=`));

    if (!cookie) return null;

    const value = cookie.split('=').slice(1).join('=');
    return value === 'KILOGRAM'
      ? 'KILOGRAM'
      : value === 'POUND'
        ? 'POUND'
        : null;
  };

export const writeStrengthWeightUnitCookie = (
  unit: StrengthWeightDisplayUnit
) => {
  if (typeof document === 'undefined') return;

  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);
  document.cookie = `${COOKIE_NAME}=${unit}; expires=${expires.toUTCString()}; path=/`;
};
